import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionDeclinedChanges = ({ transition, user, ownRole, buttons, daysUntilStart }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = get(user, 'attributes.profile.displayName', '');
  const firstName = getFirstName(displayName);

  return (
    <InboxTransitionBase
      header={
        isOwnTransition ? (
          <FormattedMessage
            id="BookingStatus.ownTransitionDeclinedChanges"
            values={{ displayName: firstName, days: daysUntilStart }}
          />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionDeclinedChanges"
            values={{ displayName: firstName, days: daysUntilStart }}
          />
        )
      }
      date={transition.createdAt}
      direction="right"
      variation="dark"
      buttons={buttons}
    >
      {isOwnTransition ? (
        <FormattedMessage
          id="BookingStatus.ownTransitionDeclinedChangesSubtext"
          values={{ displayName: firstName }}
        />
      ) : (
        <FormattedMessage
          id="BookingStatus.transitionDeclinedChangesSubtext"
          values={{ displayName: firstName }}
        />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionDeclinedChanges;
